export const PACKAGE_TEMPLATE_OPTIONS = [
  { key: "", label: "不套用（空白清单）" },
  { key: "semi", label: "半包工程 · 鲁班" },
  { key: "custom", label: "全屋定制 · 意立森" },
  { key: "window", label: "封窗工程 · 斯柏瑞" },
  { key: "daikin", label: "中央空调 · 大金一拖六" },
];

export const PACKAGE_GROUPS = {
  半包工程: [
    "客餐厅",
    "主卧",
    "主卫",
    "次卫",
    "厨房",
    "阳台",
    "书房",
    "长辈房",
    "儿童房",
    "走廊",
    "拆建工程",
    "全房基层",
    "乳胶漆",
    "综合费用一",
    "综合费用二",
    "其他",
  ],
  全屋定制: [
    "电梯厅",
    "入户隔断",
    "进门",
    "电视墙 / 阳台",
    "长辈房",
    "书房",
    "儿童房",
    "主卧",
    "走廊",
    "室内门 / 门套",
    "厨房",
    "赠品行",
    "材料标准",
    "其他",
  ],
  其他: [
    "合同规格",
    "窗型分项",
    "待定增项",
    "型材",
    "玻璃",
    "五金",
    "纱网",
    "安装与收口",
    "其他",
  ],
  家电: [
    "室外机",
    "室内机",
    "控制器",
    "新风",
    "风口 / 检修",
    "管路 / 保温",
    "安装与调试",
    "其他",
  ],
  主材: ["其他"],
  软装家具: ["其他"],
};

export const SEMI_SPACE_ROOMS = [
  "客厅",
  "餐厅",
  "走廊",
  "厨房",
  "卫生间",
  "书房",
  "儿童房",
  "长辈房",
  "主卧",
  "阳台",
];

export const CUSTOM_MATERIAL_FACTS = [
  { label: "柜体板材", value: "福人精板 18mm" },
  { label: "柜门饰面", value: "爱格 18mm" },
  { label: "封边工艺", value: "PUR / 激光" },
  { label: "厨房板材", value: "千年舟多层 18mm" },
  { label: "厨房柜门", value: "千年舟 PET" },
  { label: "厨房封边", value: "PUR" },
  { label: "室内门", value: "爱格 · 静音条 TPR" },
  { label: "灯带约定", value: "合同约定共约 20 米（已拆到各空间明细）" },
];

export function customMaterialFacts() {
  return CUSTOM_MATERIAL_FACTS;
}

const LUBAN_NOTE = "对照鲁班预算明细补数量与单价";
const CAB = {
  material: "福人精板 18mm",
  finish: "爱格 18mm",
  hardware: "PUR/激光",
  thicknessMm: "18",
};
const KIT = {
  material: "千年舟多层 18mm",
  finish: "千年舟 PET",
  hardware: "PUR",
  thicknessMm: "18",
};
const FUREN = {
  material: "福人",
  finish: "爱格 18mm",
  hardware: "PUR/激光",
  thicknessMm: "18",
};

function item(group, name, spec, room = "全屋", unit = "项", note = "", qty = 1, extra = {}) {
  return {
    group,
    name,
    spec,
    room,
    unit,
    qty,
    unitPrice: extra.unitPrice ?? 0,
    amount: extra.amount ?? 0,
    material: extra.material || "",
    finish: extra.finish || "",
    hardware: extra.hardware || "",
    opening: extra.opening || "",
    lengthMm: extra.lengthMm ?? "",
    heightMm: extra.heightMm ?? "",
    thicknessMm: extra.thicknessMm ?? "",
    note,
  };
}

function quote(
  group,
  name,
  room,
  {
    lengthMm = "",
    heightMm = "",
    thicknessMm = "",
    qty = 1,
    unit = "㎡",
    unitPrice = 0,
    amount = 0,
    material = "",
    finish = "",
    hardware = "",
    note = "",
    spec = "",
  } = {},
) {
  const dim = [lengthMm, heightMm, thicknessMm].filter((v) => v !== "" && v != null).join("×");
  return item(group, name, spec || (dim ? dim + " mm" : ""), room, unit, note, qty, {
    lengthMm,
    heightMm,
    thicknessMm,
    unitPrice,
    amount,
    material,
    finish,
    hardware,
  });
}

function roomCrafts(group, room, { waterproof = false, extra = "" } = {}) {
  const rows = [
    item(group, `${room}拆除 / 改造`, "拆除范围与改造点位待对照预算", room, "项", LUBAN_NOTE),
    item(group, `${room}水电点位`, "开关、插座、给排水点位待对照图纸", room, "项", LUBAN_NOTE),
  ];
  if (waterproof) {
    rows.push(item(group, `${room}防水`, "防水范围与闭水试验待对照预算", room, "项", LUBAN_NOTE));
  }
  rows.push(
    item(group, `${room}泥工找平贴砖`, "找平/贴砖范围待对照预算", room, "项", LUBAN_NOTE),
    item(group, `${room}木作基层吊顶`, extra || "基层、吊顶做法待对照预算", room, "项", LUBAN_NOTE),
    item(group, `${room}油漆墙面`, "墙面顶面涂饰待对照乳胶漆专章", room, "项", LUBAN_NOTE),
  );
  return rows;
}

function windowUnit(code, glass, opening, area, room = "") {
  return item(
    "窗型分项",
    code,
    "制作尺寸待对照设计图",
    room || "安装位置待补",
    "樘",
    `面积 ${area}㎡`,
    1,
    {
      material: glass,
      finish: "ZB · 弗朗曼石墨灰",
      hardware: opening,
      opening,
      lengthMm: "",
      heightMm: "",
      amount: 0,
    },
  );
}

function pay(nodeName, trigger, amount = 0) {
  return { nodeName, trigger, amount };
}

export const PACKAGE_TEMPLATES = {
  semi: {
    key: "semi",
    name: "半包工程 · 鲁班",
    category: "半包工程",
    vendor: "鲁班",
    room: "全屋",
    note: "先看空间总览，再按鲁班预算「房间工艺 + 专章」对照。数量与单价从预算补录；成交价以订单为准。",
    contractAmount: 106350,
    signedDate: "",
    durationNote: "105 有效工作日（放线完成起算）",
    warranty: "",
    items: [
      ...roomCrafts("客餐厅", "客餐厅"),
      ...roomCrafts("主卧", "主卧"),
      ...roomCrafts("主卫", "主卫", { waterproof: true, extra: "不含集成吊顶；基层吊顶待对照预算" }),
      ...roomCrafts("次卫", "次卫", { waterproof: true }),
      ...roomCrafts("厨房", "厨房", { waterproof: true }),
      ...roomCrafts("阳台", "阳台"),
      ...roomCrafts("书房", "书房"),
      ...roomCrafts("长辈房", "长辈房"),
      ...roomCrafts("儿童房", "儿童房"),
      ...roomCrafts("走廊", "走廊"),
      item("拆建工程", "墙体拆除及清运", "对照预算拆建专章补数量", "全屋", "项", LUBAN_NOTE),
      item("拆建工程", "地面拆除及清运", "对照预算拆建专章补数量", "全屋", "项", LUBAN_NOTE),
      item("拆建工程", "吊顶拆除及清运", "对照预算拆建专章补数量", "全屋", "项", LUBAN_NOTE),
      item("全房基层", "地面找平", "对照预算全房基层专章", "全屋", "项", LUBAN_NOTE),
      item("全房基层", "墙面基层处理", "对照预算全房基层专章", "全屋", "项", LUBAN_NOTE),
      item("乳胶漆", "墙面乳胶漆", "对照预算乳胶漆专章补遍数与面积", "全屋", "项", LUBAN_NOTE),
      item("乳胶漆", "顶面乳胶漆", "对照预算乳胶漆专章补遍数与面积", "全屋", "项", LUBAN_NOTE),
      item("综合费用一", "地面瓦工材料 / 粘合剂", "对照预算综合费用一", "全屋", "项", LUBAN_NOTE),
      item("综合费用一", "地面保护", "对照预算综合费用一", "全屋", "项", LUBAN_NOTE),
      item("综合费用一", "防水基层材料", "对照预算综合费用一", "全屋", "项", LUBAN_NOTE),
      item("综合费用二", "管道隔音", "对照预算综合费用二", "全屋", "项", LUBAN_NOTE),
      item("综合费用二", "红砖包管 / 壁龛", "对照预算综合费用二", "全屋", "项", LUBAN_NOTE),
      item("综合费用二", "成品保护", "对照预算综合费用二", "全屋", "项", LUBAN_NOTE),
    ],
    paymentHints: [
      pay("基础工程首期款 60%", "合同签订当日", 63810),
      pay("基础工程中期款 35%", "泥工找平后、木工施工前", 37222.5),
      pay("基础工程尾款 5%", "木工油漆后、安装开关面板前", 5317.5),
    ],
  },
  custom: {
    key: "custom",
    name: "全屋定制 · 意立森",
    category: "全屋定制",
    vendor: "意立森",
    room: "全屋",
    note: "按意立森报价投影面积明细录入。清单小计对照报价；成交价以订单 125000 为准。",
    contractAmount: 125000,
    signedDate: "2026-08-22",
    durationNote: "生产 40 天（腻子第一遍后复尺下单）；木作安装 7 天",
    warranty: "板材 5 年；五金终身",
    items: [
      // 电梯厅
      quote("电梯厅", "鞋柜", "电梯厅", { lengthMm: "860", heightMm: "2400", qty: 2.064, unitPrice: 599, amount: 1236.34, ...CAB }),
      quote("电梯厅", "矮柜", "电梯厅", { lengthMm: "750", heightMm: "1", qty: 0.75, unitPrice: 599, amount: 449.25, ...CAB }),

      // 入户隔断
      quote("入户隔断", "墙板", "入户", { lengthMm: "200", heightMm: "2640", qty: 0.528, unitPrice: 428, amount: 225, ...CAB }),
      quote("入户隔断", "墙板", "入户", { lengthMm: "200", heightMm: "2640", qty: 0.528, unitPrice: 428, amount: 225, ...CAB }),
      quote("入户隔断", "墙板", "入户", { lengthMm: "200", heightMm: "2640", qty: 0.528, unitPrice: 428, amount: 225, ...CAB }),
      quote("入户隔断", "墙板", "入户", { lengthMm: "200", heightMm: "1640", qty: 0.325, unitPrice: 428, amount: 139, ...CAB }),
      quote("入户隔断", "墙板", "入户", { lengthMm: "350", heightMm: "1640", qty: 0.574, unitPrice: 428, amount: 245, ...CAB }),
      quote("入户隔断", "墙板", "入户", { lengthMm: "350", heightMm: "1640", qty: 0.574, unitPrice: 428, amount: 245, ...CAB }),
      quote("入户隔断", "墙板", "入户", { lengthMm: "350", heightMm: "1640", qty: 0.574, unitPrice: 428, amount: 245, ...CAB }),
      quote("入户隔断", "墙板", "入户", { lengthMm: "300", heightMm: "400", qty: 0.12, unitPrice: 428, amount: 51, ...CAB }),
      quote("入户隔断", "墙板", "入户", { lengthMm: "250", heightMm: "400", qty: 0.1, unitPrice: 428, amount: 42.8, ...CAB }),
      quote("入户隔断", "墙板", "入户", { lengthMm: "200", heightMm: "400", qty: 0.08, unitPrice: 428, amount: 34, ...CAB }),
      quote("入户隔断", "墙板", "入户", { lengthMm: "150", heightMm: "1640", qty: 0.246, unitPrice: 428, amount: 105.2, ...CAB }),
      quote("入户隔断", "海棠角", "入户", { qty: 16, unit: "项", unitPrice: 55, amount: 880 }),

      // 进门
      quote("进门", "鞋柜", "进门", { lengthMm: "2390", heightMm: "2640", qty: 6.31, unitPrice: 1050, amount: 6625.08, ...CAB }),
      quote("进门", "高柜", "进门", { lengthMm: "640", heightMm: "2640", qty: 1.69, unitPrice: 1050, amount: 1774.08, ...CAB }),
      quote("进门", "拉直器", "进门", { qty: 2, unit: "个", unitPrice: 90, amount: 180, note: "威发" }),
      quote("进门", "见光板", "进门", { lengthMm: "600", heightMm: "2640", qty: 1.584, unitPrice: 328, amount: 519.55, ...CAB }),
      quote("进门", "铣槽拉手", "进门", { qty: 1, unit: "米", unitPrice: 90, amount: 90, note: "1米" }),
      quote("进门", "通体铣槽拉手", "进门", { qty: 2, unit: "个", unitPrice: 150, amount: 300 }),
      quote("进门", "墙板", "进门", { lengthMm: "4280", heightMm: "600", qty: 2.568, unitPrice: 428, amount: 1099.1, ...CAB }),
      quote("进门", "落地电视柜", "进门", { qty: 4.28, unitPrice: 1050, amount: 4494, ...CAB }),

      // 电视墙 / 阳台
      quote("电视墙 / 阳台", "阳台柜", "阳台", { lengthMm: "1230", heightMm: "2640", qty: 3.247, unitPrice: 1050, amount: 3409.56, ...CAB }),
      quote("电视墙 / 阳台", "阳台柜", "阳台", { lengthMm: "1230", heightMm: "2640", qty: 3.247, unitPrice: 1050, amount: 3409.56, ...CAB }),
      quote("电视墙 / 阳台", "灯带", "阳台", { qty: 2.5, unit: "米", unitPrice: 85, amount: 212.5 }),
      quote("电视墙 / 阳台", "稳压器+开关", "阳台", { qty: 1, unit: "套", unitPrice: 200, amount: 200 }),
      quote("电视墙 / 阳台", "拉直器", "阳台", { qty: 2, unit: "个", unitPrice: 90, amount: 180 }),
      quote("电视墙 / 阳台", "餐边柜", "客餐厅", { lengthMm: "4295", heightMm: "2640", qty: 11.339, unitPrice: 1050, amount: 11905.74, ...CAB }),
      quote("电视墙 / 阳台", "灯带", "客餐厅", { qty: 4.8, unit: "米", unitPrice: 85, amount: 408 }),
      quote("电视墙 / 阳台", "稳压器+开关", "客餐厅", { qty: 1, unit: "套", unitPrice: 200, amount: 200 }),
      quote("电视墙 / 阳台", "圆弧250（福人）", "客餐厅", { qty: 2.5, unit: "项", unitPrice: 1280, amount: 3200, ...FUREN }),
      quote("电视墙 / 阳台", "冰箱柜（福人）", "客餐厅", { lengthMm: "950", heightMm: "2640", qty: 2.508, unitPrice: 850, amount: 2131.8, ...FUREN }),

      // 长辈房
      quote("长辈房", "衣柜", "长辈房", { lengthMm: "1690", heightMm: "2640", qty: 4.462, unitPrice: 1050, amount: 4684.68, ...CAB }),
      quote("长辈房", "见光板", "长辈房", { lengthMm: "600", heightMm: "2640", qty: 1.584, unitPrice: 328, amount: 519.55, ...CAB }),
      quote("长辈房", "铣槽拉手", "长辈房", { qty: 2, unit: "米", unitPrice: 90, amount: 180 }),
      quote("长辈房", "半墙福人", "长辈房", { lengthMm: "4100", heightMm: "1050", qty: 4.305, unitPrice: 398, amount: 1713.39, ...FUREN }),
      quote("长辈房", "灯带", "长辈房", { qty: 4.1, unit: "米", unitPrice: 85, amount: 348.5 }),
      quote("长辈房", "稳压器+开关", "长辈房", { qty: 1, unit: "套", unitPrice: 200, amount: 200 }),

      // 书房
      quote("书房", "储物柜", "书房", { lengthMm: "2870", heightMm: "2640", qty: 7.577, unitPrice: 1050, amount: 7955.64, ...CAB }),
      quote("书房", "灯带", "书房", { qty: 11, unit: "米", unitPrice: 85, amount: 935 }),
      quote("书房", "稳压器+开关", "书房", { qty: 1, unit: "套", unitPrice: 200, amount: 200 }),
      quote("书房", "稳压器+开关", "书房", { qty: 1, unit: "套", unitPrice: 200, amount: 200 }),
      quote("书房", "书桌", "书房", { lengthMm: "2850", qty: 2.85, unit: "米", unitPrice: 850, amount: 2422.5, ...CAB }),
      quote("书房", "吊柜", "书房", { lengthMm: "2870", heightMm: "1100", qty: 3.157, unitPrice: 1050, amount: 3314.85, ...CAB }),
      quote("书房", "钢架", "书房", { lengthMm: "2870", qty: 2.87, unit: "米", unitPrice: 850, amount: 2439.5, note: "钢架" }),
      quote("书房", "三抽", "书房", { qty: 3, unit: "个", unitPrice: 200, amount: 600, ...CAB }),
      quote("书房", "墙板福人", "书房", { lengthMm: "1300", heightMm: "2850", qty: 3.705, unitPrice: 398, amount: 1474.59, ...FUREN }),
      quote("书房", "洗衣柜", "书房", { lengthMm: "985", heightMm: "2640", qty: 2.6, unitPrice: 1050, amount: 2730, ...CAB }),

      // 儿童房
      quote("儿童房", "衣柜", "儿童房", { lengthMm: "1415", heightMm: "2640", qty: 3.736, unitPrice: 1050, amount: 3922.38, ...CAB }),
      quote("儿童房", "铣槽拉手", "儿童房", { qty: 1, unit: "米", unitPrice: 90, amount: 90, note: "1米" }),

      // 主卧
      quote("主卧", "床尾柜", "主卧", { lengthMm: "5180", heightMm: "2640", qty: 13.675, unitPrice: 1050, amount: 14358.96, ...CAB }),
      quote("主卧", "铣槽拉手", "主卧", { qty: 3, unit: "米", unitPrice: 90, amount: 270 }),
      quote("主卧", "墙板福人", "主卧", { lengthMm: "3270", heightMm: "2640", qty: 8.633, unitPrice: 398, amount: 3435.85, ...FUREN }),
      quote("主卧", "格栅", "主卧", { lengthMm: "300", heightMm: "1440", qty: 0.432, unitPrice: 528, amount: 228, ...CAB }),
      quote("主卧", "灯带", "主卧", { qty: 8, unit: "米", unitPrice: 85, amount: 680 }),
      quote("主卧", "稳压器+开关", "主卧", { qty: 1, unit: "套", unitPrice: 200, amount: 200 }),
      quote("主卧", "稳压器+开关", "主卧", { qty: 1, unit: "套", unitPrice: 200, amount: 200 }),

      // 走廊
      quote("走廊", "柜子", "走廊", { lengthMm: "1540", heightMm: "2640", qty: 4.066, unitPrice: 1050, amount: 4268.88, ...CAB }),
      quote("走廊", "铣槽拉手", "走廊", { qty: 1, unit: "米", unitPrice: 90, amount: 90, note: "1米" }),
      quote("走廊", "铣槽拉手", "走廊", { qty: 1, unit: "米", unitPrice: 90, amount: 90, note: "1米" }),
      quote("走廊", "柜子", "走廊", { lengthMm: "550", heightMm: "2500", qty: 1.375, unitPrice: 398, amount: 547.25, ...CAB }),
      quote("走廊", "两抽", "走廊", { qty: 2, unit: "个", unitPrice: 200, amount: 400, ...CAB }),
      quote("走廊", "灯带", "走廊", { qty: 1, unit: "米", unitPrice: 85, amount: 85 }),
      quote("走廊", "稳压器+开关", "走廊", { qty: 1, unit: "套", unitPrice: 200, amount: 200 }),
      quote("走廊", "抽屉", "走廊", { qty: 2, unit: "个", unitPrice: 350, amount: 700, ...CAB }),

      // 室内门 / 门套
      quote("室内门 / 门套", "爱格室内门", "全屋", {
        qty: 4,
        unit: "扇",
        unitPrice: 2680,
        amount: 10720,
        finish: "爱格",
        note: "静音条TPR",
      }),
      quote("室内门 / 门套", "地脚线", "全屋", { qty: 30, unit: "米", unitPrice: 40, amount: 1200 }),
      quote("室内门 / 门套", "入户门套", "入户", { qty: 23.5, unit: "米", unitPrice: 145, amount: 3407.5 }),

      // 厨房
      quote("厨房", "高柜", "厨房", { lengthMm: "600", heightMm: "2450", qty: 1.47, unitPrice: 850, amount: 1249, ...KIT }),
      quote("厨房", "地柜", "厨房", { qty: 6.4, unitPrice: 700, amount: 4480, ...KIT }),
      quote("厨房", "吊柜", "厨房", { qty: 4.2, unitPrice: 550, amount: 2310, ...KIT }),
      quote("厨房", "台面纯色2.0石英石", "厨房", {
        qty: 6.4,
        unitPrice: 600,
        amount: 3840,
        material: "石英石（含量≥96%）",
        finish: "纯色",
        hardware: "—",
        note: "厚 2.0cm",
      }),
      quote("厨房", "台中开孔费", "厨房", { qty: 1, unit: "项", unitPrice: 150, amount: 150 }),
      quote("厨房", "百叶门", "厨房", { qty: 1, unit: "项", unitPrice: 120, amount: 120 }),
      quote("厨房", "水盆+拉篮+龙头", "厨房", { qty: 1, unit: "套", unitPrice: 0, amount: 0, note: "赠送" }),
      quote("厨房", "水柜", "厨房", { qty: 0, unit: "项", unitPrice: 0, amount: 0, note: "手写待补，不编数量" }),
      quote("厨房", "镜柜", "厨房", { qty: 0, unit: "项", unitPrice: 0, amount: 0, note: "手写待补，不编数量" }),

      // 赠品行
      quote("赠品行", "玻璃门", "厨房", {
        qty: 5,
        unit: "㎡",
        unitPrice: 0,
        amount: 0,
        note: "约 5㎡ · 3C；合同赠送",
      }),
      quote("赠品行", "悍高3.0碗碟拉篮", "厨房", {
        qty: 1,
        unit: "套",
        unitPrice: 0,
        amount: 0,
        material: "悍高",
        note: "合同赠送",
      }),
      quote("赠品行", "悍高水槽龙头", "厨房", {
        qty: 1,
        unit: "套",
        unitPrice: 0,
        amount: 0,
        material: "悍高",
        note: "合同赠送",
      }),
      quote("赠品行", "灯带约定", "全屋", {
        qty: 0,
        unit: "米",
        unitPrice: 0,
        amount: 0,
        note: "合同约定共约20米已拆到各空间；材料标准卡登记，本行不重复加计",
      }),
    ],
    paymentHints: [
      pay("首付款 50%", "合同签订当日", 62500),
      pay("生产 / 送货款 40%", "复尺后进入生产、送货前", 50000),
      pay("尾款 10%", "安装验收合格后", 12500),
    ],
  },
  window: {
    key: "window",
    name: "封窗工程 · 斯柏瑞",
    category: "其他",
    vendor: "斯柏瑞",
    room: "全屋",
    note: "按窗号 C1–C5 登记。签约已付33800、尾款2000；厨房窗待定约2300不计入当前合同额。制作尺寸待对照设计图，勿估宽高。",
    contractAmount: 35800,
    signedDate: "2026-08-23",
    durationNote: "付款后 25 个工作日",
    warranty: "产品 15 年；中空玻璃 25 年",
    items: [
      item(
        "合同规格",
        "系列 / 颜色 / 玻璃 / 五金",
        "问界95单体窗系列；内埃及灰 / 外星际灰；按窗号玻璃；诺托隐形内开内倒；纱网 ZB；执手弗朗曼无底座·石墨灰",
        "全屋",
        "项",
        "全屋统一规格，窗号行引用此口径",
        1,
        {
          material: "问界95单体窗系列",
          finish: "内埃及灰 / 外星际灰",
          hardware: "诺托隐形内开内倒",
        },
      ),
      windowUnit("C1", "6+18A+6钢化", "内开内倒90°", 12.19),
      windowUnit("C2", "6+18A+6钢化", "内开内倒90°", 7.93),
      windowUnit("C3", "5+12A+5+12A+5钢化", "内开内倒180°", 3.2),
      windowUnit("C4", "5+12A+5+12A+5钢化", "内开内倒180°", 4.31),
      windowUnit("C5", "5+12A+5+12A+5钢化", "内开内倒180°", 2.07),
      item(
        "待定增项",
        "厨房窗（待定）",
        "制作尺寸待对照设计图",
        "厨房",
        "樘",
        "未签约，约 ¥2,300，不计入当前合同额",
        1,
        { material: "待定", finish: "待定", hardware: "待定" },
      ),
      item("型材", "问界95单体窗系列", "按合同", "全屋", "项", "", 1, { material: "问界95单体窗系列" }),
      item(
        "玻璃",
        "中空钢化（按窗号）",
        "6+18A+6钢化 / 5+12A+5+12A+5钢化",
        "全屋",
        "项",
        "C1–C2 双玻；C3–C5 三玻两腔",
        1,
        { material: "中空钢化" },
      ),
      item("五金", "诺托隐形内开内倒", "按合同", "全屋", "项", "执手：弗朗曼无底座·石墨灰", 1, {
        hardware: "诺托隐形内开内倒",
      }),
      item("纱网", "ZB", "按合同", "全屋", "项", "执手弗朗曼无底座·石墨灰", 1, { material: "ZB" }),
      item("安装与收口", "安装与旧窗拆除", "侧贴扣板、铝板收口；结构损伤不担责", "全屋"),
    ],
    paymentHints: [
      pay("签约款", "合同签订（已付）", 33800),
      pay("尾款", "安装完成、开票前", 2000),
    ],
  },
  daikin: {
    key: "daikin",
    name: "中央空调 · 大金一拖六",
    category: "家电",
    vendor: "大金",
    room: "全屋",
    note: "设备销售及安装合同。清单对照范围；室内机房间深化后补；成交价以订单为准。",
    contractAmount: 61000,
    signedDate: "2026-06-28",
    durationNote: "到货 5–7 工作日；安装 3–4 工作日",
    warranty: "设备 3 年；安装 5 年",
    items: [
      item("室外机", "RQRP160APN", "一拖六室外机 ×1", "室外", "台"),
      item("室内机", "FXDP71GAN", "室内机 ×1 · 安装房间待补", "安装房间待定", "台"),
      item("室内机", "FXDP56EAN", "室内机 ×1 · 安装房间待补", "安装房间待定", "台"),
      item("室内机", "FXDP22GAN", "室内机 ×1 · 安装房间待补", "安装房间待定", "台", "#1 安装房间待定"),
      item("室内机", "FXDP22GAN", "室内机 ×1 · 安装房间待补", "安装房间待定", "台", "#2 安装房间待定"),
      item("室内机", "FXDP28GAN", "室内机 ×1 · 安装房间待补", "安装房间待定", "台"),
      item("控制器", "BRC4C152 / 7DBW", "线控 ×1", "全屋", "台"),
      item("风口 / 检修", "标准 ABS 风口", "出回风口尺寸按深化图", "全屋"),
      item("管路 / 保温", "冷媒管 / 保温 / 排水", "含标准安装", "全屋"),
      item("安装与调试", "隐蔽验收 / 试机", "压力保压 4.0MPa；调试合格", "全屋"),
    ],
    paymentHints: [
      pay("定金", "合同签订", 30000),
      pay("余款", "送货进场前一日", 31000),
    ],
  },
};

export const COARSE_PLACEHOLDER_NAMES = [
  "客餐厅分项",
  "主卧分项",
  "主卫分项",
  "次卫分项",
  "厨房分项",
  "阳台分项",
  "书房分项",
  "长辈房分项",
  "儿童房分项",
  "走廊分项",
  "拆建工程",
  "全房基层",
  "乳胶漆",
  "综合费用一",
  "综合费用二",
  "入户隔断 / 电梯厅鞋柜",
  "进门鞋柜 / 高柜 / 电视柜",
  "储物柜 / 书桌 / 吊柜 / 钢架",
  "衣柜 / 半墙 / 见光板",
  "高柜 / 地柜 / 吊柜",
  "悍高拉篮 / 水槽龙头 / 玻璃门等",
  "窗型分项（按位置登记）",
  "客餐厅窗",
  "主卧窗",
  "儿童房窗",
  "书房窗",
  "长辈房窗",
  "阳台窗",
  "入户鞋柜",
  "入户矮柜",
  "入户隔断墙板",
  "入户海棠角",
  "进门鞋柜",
  "进门高柜",
  "进门墙板",
  "拉手 / 拉直器",
  "落地电视柜",
  "餐边柜",
  "餐边圆弧",
  "餐边灯带",
  "阳台柜体",
  "冰箱柜",
  "长辈房衣柜",
  "长辈房半墙",
  "长辈房见光板",
  "书房储物柜",
  "书桌",
  "书房吊柜",
  "钢架",
  "三抽",
  "书房墙板",
  "洗衣柜",
  "儿童房衣柜",
  "主卧墙板 / 格栅",
  "床尾柜",
  "走廊柜",
  "室内门",
  "入户门套",
  "地脚线",
  "厨房高柜",
  "厨房地柜",
  "厨房吊柜",
  "石英石台面",
  "台面开孔 / 百叶",
  "悍高拉篮",
  "水槽龙头",
  "玻璃门",
  "灯带（赠送）",
  "W×D×H 待复尺",
];

export const QUOTE_SUPERSEDED_NAMES = [
  "入户鞋柜",
  "入户矮柜",
  "入户隔断墙板",
  "入户海棠角",
  "进门鞋柜",
  "进门高柜",
  "进门墙板",
  "拉手 / 拉直器",
  "落地电视柜",
  "餐边柜",
  "餐边圆弧",
  "餐边灯带",
  "阳台柜体",
  "冰箱柜",
  "长辈房衣柜",
  "长辈房半墙",
  "长辈房见光板",
  "书房储物柜",
  "书桌",
  "书房吊柜",
  "钢架",
  "三抽",
  "书房墙板",
  "洗衣柜",
  "儿童房衣柜",
  "主卧墙板 / 格栅",
  "床尾柜",
  "走廊柜",
  "室内门",
  "入户门套",
  "地脚线",
  "厨房高柜",
  "厨房地柜",
  "厨房吊柜",
  "石英石台面",
  "台面开孔 / 百叶",
  "悍高拉篮",
  "水槽龙头",
  "玻璃门",
  "灯带（赠送）",
  "W×D×H 待复尺",
  "客餐厅窗",
  "主卧窗",
  "儿童房窗",
  "书房窗",
  "长辈房窗",
  "阳台窗",
];

export function groupsForCategory(category) {
  return PACKAGE_GROUPS[category] || PACKAGE_GROUPS["其他"];
}

export function allSpecGroups() {
  const seen = new Set();
  const groups = [];
  Object.values(PACKAGE_GROUPS).forEach((list) => {
    list.forEach((group) => {
      if (!seen.has(group)) {
        seen.add(group);
        groups.push(group);
      }
    });
  });
  return groups;
}

export function inferSpecGroup(name = "", category = "") {
  const n = String(name);
  const groups = groupsForCategory(category);
  const pick = (re, group) => (re.test(n) && groups.includes(group) ? group : "");
  if (category === "半包工程") {
    return (
      pick(/客餐|客厅|餐厅/, "客餐厅") ||
      pick(/主卫/, "主卫") ||
      pick(/次卫|公卫/, "次卫") ||
      pick(/厨房/, "厨房") ||
      pick(/阳台/, "阳台") ||
      pick(/书房/, "书房") ||
      pick(/长辈/, "长辈房") ||
      pick(/儿童/, "儿童房") ||
      pick(/走廊/, "走廊") ||
      pick(/主卧/, "主卧") ||
      pick(/拆|拆除/, "拆建工程") ||
      pick(/基层/, "全房基层") ||
      pick(/乳胶漆|油漆|涂料/, "乳胶漆") ||
      pick(/综合费用一|瓦工材料|粘合剂|地面保护/, "综合费用一") ||
      pick(/综合费用二|包管|壁龛|成品保护|隔音/, "综合费用二") ||
      (groups.includes("其他") ? "其他" : groups[0] || "其他")
    );
  }
  if (category === "全屋定制") {
    return (
      pick(/电梯/, "电梯厅") ||
      pick(/隔断|海棠/, "入户隔断") ||
      pick(/进门/, "进门") ||
      pick(/阳台|餐边|电视|冰箱|圆弧/, "电视墙 / 阳台") ||
      pick(/长辈/, "长辈房") ||
      pick(/书房|书桌|钢架|三抽|洗衣/, "书房") ||
      pick(/儿童/, "儿童房") ||
      pick(/床尾|格栅/, "主卧") ||
      pick(/走廊|两抽|抽屉/, "走廊") ||
      pick(/室内门|门套|地脚|爱格室内门/, "室内门 / 门套") ||
      pick(/厨|地柜|吊柜|高柜|台面|石英石|开孔|百叶|水柜|镜柜|水盆/, "厨房") ||
      pick(/赠|悍高|水槽|玻璃门|拉篮|灯带约定/, "赠品行") ||
      pick(/材料标准|板材标准/, "材料标准") ||
      (groups.includes("其他") ? "其他" : groups[0] || "其他")
    );
  }
  if (category === "家电") {
    return (
      pick(/室外/, "室外机") ||
      pick(/室内|FXDP|FCQ/, "室内机") ||
      pick(/线控|控制器|BRC/, "控制器") ||
      pick(/新风/, "新风") ||
      pick(/风口|检修/, "风口 / 检修") ||
      pick(/管|保温|排水|冷媒/, "管路 / 保温") ||
      pick(/安装|调试|试机|验收/, "安装与调试") ||
      (groups.includes("其他") ? "其他" : groups[0] || "其他")
    );
  }
  return (
    pick(/厨房.*待定|待定/, "待定增项") ||
    pick(/规格|系列|颜色/, "合同规格") ||
    pick(/窗|封窗|扇|樘|C[1-5]/, "窗型分项") ||
    pick(/型材/, "型材") ||
    pick(/玻璃/, "玻璃") ||
    pick(/纱网/, "纱网") ||
    pick(/安装|拆除|收口/, "安装与收口") ||
    pick(/五金|诺托|执手/, "五金") ||
    (groups.includes("其他") ? "其他" : groups[0] || "其他")
  );
}

export function templateByKey(key) {
  return PACKAGE_TEMPLATES[key] || null;
}

export function templateKeyForPackage(pkg = {}) {
  const source = String(pkg.source || "");
  if (source === "luban-seed" || source === "semi-template") return "semi";
  if (source === "custom-seed" || source === "custom-template") return "custom";
  if (source === "window-seed" || source === "window-template") return "window";
  if (source === "daikin-seed" || source === "daikin-template") return "daikin";
  const category = pkg.category || "";
  const text = `${pkg.name || ""}${pkg.vendor || ""}`;
  if (category === "半包工程" || /鲁班|半包/.test(text)) return "semi";
  if (category === "全屋定制" || /意立森|定制/.test(text)) return "custom";
  if (/封窗|斯柏瑞|门窗/.test(text)) return "window";
  if (category === "家电" && /大金|空调|一拖六/.test(text)) return "daikin";
  if (/封窗|窗/.test(text)) return "window";
  return "";
}

export const WINDOW_SYSTEM_GROUPS = ["合同规格", "型材", "玻璃", "五金", "纱网", "安装与收口"];
export const WINDOW_OPENING_GROUPS = ["窗型分项", "待定增项"];

const COL_NAME = { key: "name", label: "名称", kind: "name" };
const COL_ROOM = { key: "room", label: "空间", kind: "text" };
const COL_SPEC = { key: "spec", label: "说明", kind: "text" };
const COL_QTY = { key: "qty", label: "数量", kind: "qty" };
const COL_UNIT = { key: "unit", label: "单位", kind: "text" };
const COL_NOTE = { key: "note", label: "备注", kind: "text" };
const COL_PRICE = { key: "unitPrice", label: "单价", kind: "money" };
const COL_AMOUNT = { key: "amount", label: "金额", kind: "amount" };

export const SPEC_SCHEMAS = {
  semi: {
    key: "semi",
    itemTitle: "添加工艺分项",
    help: "对照鲁班预算补做法、工程量和单价。不要填柜体板材、颜色或五金。没有的数字保持待补，不要估。",
    columns: [
      { ...COL_NAME, label: "分项" },
      COL_ROOM,
      { key: "spec", label: "做法", kind: "text" },
      { ...COL_QTY, label: "工程量" },
      COL_UNIT,
      COL_PRICE,
      COL_AMOUNT,
      COL_NOTE,
    ],
    form: [
      { name: "name", label: "分项名称", required: true },
      { name: "group", label: "分组", options: "groups" },
      { name: "room", label: "空间", options: "rooms" },
      { name: "spec", label: "做法 / 工艺说明", full: true },
      { name: "qty", label: "工程量", type: "number" },
      { name: "unit", label: "单位" },
      { name: "unitPrice", label: "单价（元）", type: "number" },
      { name: "amount", label: "金额（元，留空则按数量×单价）", type: "number" },
      { name: "note", label: "备注", type: "textarea", full: true },
    ],
  },
  custom: {
    key: "custom",
    itemTitle: "添加报价分项",
    help: "按报价长×高与投影面积录入。进深未写保持待补。清单小计对照报价；成交价以订单为准。",
    columns: [
      { ...COL_NAME, label: "分项" },
      COL_ROOM,
      { key: "lengthMm", label: "长mm", kind: "text" },
      { key: "heightMm", label: "高mm", kind: "text" },
      { key: "thicknessMm", label: "厚mm", kind: "text" },
      { ...COL_QTY, label: "投影面积/数量" },
      COL_UNIT,
      { key: "material", label: "柜体板材", kind: "text" },
      { key: "finish", label: "柜门", kind: "text" },
      { key: "hardware", label: "封边", kind: "text" },
      COL_PRICE,
      { ...COL_AMOUNT, label: "小计" },
      COL_NOTE,
    ],
    form: [
      { name: "name", label: "分项名称", required: true },
      { name: "group", label: "分组", options: "groups" },
      { name: "room", label: "空间", options: "rooms" },
      { name: "lengthMm", label: "长 mm" },
      { name: "heightMm", label: "高 mm" },
      { name: "thicknessMm", label: "厚 mm" },
      { name: "qty", label: "投影面积 / 数量", type: "number" },
      { name: "unit", label: "单位" },
      { name: "material", label: "柜体板材" },
      { name: "finish", label: "柜门" },
      { name: "hardware", label: "封边" },
      { name: "unitPrice", label: "单价（元）", type: "number" },
      { name: "amount", label: "小计（元）", type: "number" },
      { name: "note", label: "备注", type: "textarea", full: true },
    ],
  },
  window: {
    key: "window",
    itemTitle: "添加窗号",
    help: "按窗号填安装位置、宽×高（待补勿估）、面积、玻璃与开启。系列与颜色在上方系统规格统一登记。",
    systemGroups: WINDOW_SYSTEM_GROUPS,
    openingGroups: WINDOW_OPENING_GROUPS,
    columns: [
      { ...COL_NAME, label: "窗号" },
      { ...COL_ROOM, label: "安装位置" },
      { key: "windowSize", label: "宽×高", kind: "windowSize" },
      { key: "material", label: "玻璃", kind: "text" },
      { key: "opening", label: "开启/五金", kind: "opening" },
      { key: "finish", label: "纱窗/执手", kind: "text" },
      { ...COL_QTY, label: "樘数" },
      COL_NOTE,
    ],
    form: [
      { name: "name", label: "窗号", required: true },
      { name: "group", label: "分组", options: "groups" },
      { name: "room", label: "安装位置", options: "rooms" },
      { name: "spec", label: "宽×高（待补勿估）" },
      { name: "material", label: "玻璃" },
      { name: "opening", label: "开启 / 五金" },
      { name: "finish", label: "纱窗 / 执手" },
      { name: "qty", label: "樘数", type: "number" },
      { name: "unit", label: "单位" },
      { name: "note", label: "备注（可含面积）", type: "textarea", full: true },
    ],
  },
  windowSystem: {
    key: "windowSystem",
    itemTitle: "编辑系统规格",
    help: "问界95单体窗系列：内埃及灰 / 外星际灰；诺托隐形内开内倒；纱网 ZB；执手弗朗曼无底座·石墨灰。洞口行只引用这一口径。",
    columns: [
      { ...COL_NAME, label: "项目" },
      { key: "spec", label: "规格说明", kind: "text" },
      { key: "material", label: "系列 / 材料", kind: "text" },
      { key: "finish", label: "颜色", kind: "text" },
      { key: "hardware", label: "五金", kind: "text" },
      COL_NOTE,
    ],
    form: [
      { name: "name", label: "项目", required: true },
      { name: "group", label: "分组", options: "groups" },
      { name: "spec", label: "规格说明", full: true },
      { name: "material", label: "系列 / 材料" },
      { name: "finish", label: "室内外颜色" },
      { name: "hardware", label: "五金" },
      { name: "note", label: "备注", type: "textarea", full: true },
    ],
  },
  daikin: {
    key: "daikin",
    itemTitle: "添加设备 / 安装项",
    help: "填型号、安装房间和数量。空调不是柜体，不要填板材、颜色、五金。室内机房间没定就保持「安装房间待定」。",
    columns: [
      { ...COL_ROOM, label: "安装位置" },
      { ...COL_NAME, label: "设备" },
      { key: "spec", label: "型号与参数", kind: "text" },
      COL_QTY,
      COL_UNIT,
      COL_NOTE,
    ],
    form: [
      { name: "name", label: "设备 / 工作", required: true },
      { name: "group", label: "分组", options: "groups" },
      { name: "room", label: "安装位置", options: "rooms" },
      { name: "spec", label: "型号与参数", full: true },
      { name: "qty", label: "数量", type: "number" },
      { name: "unit", label: "单位" },
      { name: "note", label: "备注", type: "textarea", full: true },
    ],
  },
  default: {
    key: "default",
    itemTitle: "添加明细",
    help: "按实际内容填写名称、说明和数量。没有板材或五金就不要硬填。",
    columns: [
      COL_NAME,
      COL_ROOM,
      COL_SPEC,
      COL_QTY,
      COL_UNIT,
      COL_NOTE,
    ],
    form: [
      { name: "name", label: "名称", required: true },
      { name: "group", label: "分组", options: "groups" },
      { name: "room", label: "空间", options: "rooms" },
      { name: "spec", label: "说明", full: true },
      { name: "qty", label: "数量", type: "number" },
      { name: "unit", label: "单位" },
      { name: "note", label: "备注", type: "textarea", full: true },
    ],
  },
};

export function specSchemaByKey(key = "") {
  return SPEC_SCHEMAS[key] || SPEC_SCHEMAS.default;
}

export function specSchemaForPackage(pkg = {}) {
  return specSchemaByKey(templateKeyForPackage(pkg));
}

export function isWindowSystemGroup(group = "") {
  return WINDOW_SYSTEM_GROUPS.includes(String(group || ""));
}

export function isWindowOpeningGroup(group = "") {
  return WINDOW_OPENING_GROUPS.includes(String(group || "")) || /窗/.test(String(group || ""));
}

export function specSchemaForItem(pkg = {}, item = {}) {
  const key = templateKeyForPackage(pkg);
  if (key === "window" && isWindowSystemGroup(item.group)) return SPEC_SCHEMAS.windowSystem;
  return specSchemaByKey(key);
}

export function windowOpeningValue(item = {}) {
  const direct = String(item.opening || "").trim();
  if (direct) return direct;
  const spec = String(item.spec || "");
  const hit = spec.match(/(平开|推拉|内开|外开|上悬|内倒|固定扇|固定)/);
  return hit ? hit[1] : "";
}

export function windowSizeValue(item = {}) {
  let spec = String(item.spec || "").trim();
  if (!spec) return "";
  if (/制作尺寸待对照|待补|待复尺/.test(spec) && !/\d+\s*[×xX]\s*\d+/.test(spec)) return "";
  spec = spec
    .replace(/[×xX]\s*开启方式.*$/u, "")
    .replace(/开启方式.*$/u, "")
    .replace(/[·•]\s*待复尺.*$/u, "")
    .trim();
  return spec;
}

export function windowSystemFacts(items = []) {
  const byGroup = (group) => items.find((x) => x.group === group) || null;
  const spec = byGroup("合同规格");
  const profile = byGroup("型材");
  const glass = byGroup("玻璃");
  const hardware = byGroup("五金");
  const mesh = byGroup("纱网");
  const install = byGroup("安装与收口");
  const handleHint =
    (hardware?.note && /执手/.test(hardware.note) ? hardware.note : "") ||
    (mesh?.note && /执手|弗朗曼/.test(mesh.note) ? mesh.note : "") ||
    "弗朗曼无底座·石墨灰";
  return [
    { label: "系列 / 型材", value: spec?.material || profile?.material || profile?.spec || spec?.spec || "" },
    { label: "室内外颜色", value: spec?.finish || "" },
    { label: "玻璃", value: glass?.spec || glass?.material || "" },
    { label: "五金 / 开启", value: hardware?.hardware || hardware?.name || spec?.hardware || "" },
    { label: "纱网", value: mesh?.spec || mesh?.material || mesh?.name || "" },
    { label: "执手", value: handleHint },
    { label: "安装 / 收口", value: install?.spec || install?.note || "" },
  ];
}
